import { createFileRoute } from '@tanstack/react-router';

import { LaunchChecklistCard } from '@/features/launch';
import { StoreSettingsPage, storePageSearchSchema, storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/org/stores/$storeId')({
  staticData: { tours: ['settings.hub', 'settings.store-details'] },
  validateSearch: storePageSearchSchema,
  loader: async ({ context, params }) => {
    const store = await context.queryClient.query({
      ...storeQueryOptions(params.storeId),
      staleTime: 'static',
    });
    return { crumb: store.name };
  },
  component: StorePage,
});

/** The checklist reads the settings features, which read stores, so the route composes it in. */
function StorePage() {
  const { storeId } = Route.useParams();
  return (
    <StoreSettingsPage
      hubAside={
        <LaunchChecklistCard storeId={storeId} tour={{ card: 'settings.hub.launch-checklist' }} />
      }
    />
  );
}
